import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useFirstRuleKind } from '@/features/rules/pages/rules-pages';

function RulesIndex() {
  const kind = useFirstRuleKind();
  return kind ? <Navigate to={`/rules/${kind}` as never} replace /> : null;
}

export const Route = createFileRoute('/_app/rules/')({ component: RulesIndex });
